import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    try {
      
      this.logHeightNow()
      this.setupScrollLogging()
      this.setupPeriodicLogging()
      
      window.logVehiclesHeight = () => this.logHeightNow()
      window.logScrollNow = () => this.logCurrentScroll()
      
    } catch (error) {
    }
  }
  
  logHeightNow() {
    try {
      const element = this.element
      const rect = element.getBoundingClientRect()
      const computed = window.getComputedStyle(element)
      const cards = element.querySelectorAll('.vehicle-card')
      
      
      // Verificar overflow
      const isOverflowing = element.scrollHeight > element.clientHeight
      const overflowAmount = element.scrollHeight - element.clientHeight
      
    } catch (error) {
    }
  }
  
  setupScrollLogging() {
    try {
      const scrollContainer = this.findScrollContainer()
      
      if (scrollContainer) {
        
        const throttledLog = this.throttle(() => {
          this.logCurrentScroll()
        }, 500) 
        
        scrollContainer.addEventListener('scroll', throttledLog, { passive: true })
        this.scrollHandler = throttledLog
        this.scrollContainer = scrollContainer
        
      } else {
      }
    } catch (error) {
    }
  }
  
  findScrollContainer() {
    // Tentar encontrar o container que faz scroll
    let current = this.element.parentElement
    
    while (current && current !== document.body) {
      const computed = window.getComputedStyle(current)
      if (computed.overflowY === 'auto' || computed.overflowY === 'scroll') {
        return current
      }
      current = current.parentElement
    }
    
    // Se não encontrar, usar window
    return window
  }
  
  logCurrentScroll() {
    try {
      const rect = this.element.getBoundingClientRect()
      const scrollContainer = this.scrollContainer || window
      
      const scrollTop = scrollContainer === window ? 
        window.pageYOffset : 
        scrollContainer.scrollTop
      
    } catch (error) {
    }
  }
  
  setupPeriodicLogging() {
    // Log automático a cada 5 segundos
    this.periodicInterval = setInterval(() => {
      this.logHeightNow()
    }, 5000)
  }
  
  throttle(func, limit) {
    let inThrottle
    return function() {
      const args = arguments
      const context = this
      if (!inThrottle) {
        func.apply(context, args)
        inThrottle = true
        setTimeout(() => inThrottle = false, limit)
      }
    }
  }
  
  disconnect() {
    if (this.periodicInterval) {
      clearInterval(this.periodicInterval)
    }
    if (this.scrollHandler && this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.scrollHandler)
    }
  }
}